import { useState, useEffect } from "react";

// Tablet viewport: >= 768px (md) and < 1024px (lg)
const TABLET_MIN_WIDTH = 768;
const TABLET_MAX_WIDTH = 1025;

/**
 * Determine if the current viewport is in tablet range (768px - 1023px)
 */
const useIsTablet = () => {
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const checkIsTablet = () => {
      const width = window.innerWidth;
      setIsTablet(width >= TABLET_MIN_WIDTH && width < TABLET_MAX_WIDTH);
    };

    checkIsTablet();

    window.addEventListener("resize", checkIsTablet);

    return () => window.removeEventListener("resize", checkIsTablet);
  }, []);

  return isTablet;
};

export default useIsTablet;
